var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-cascader',{staticStyle:{"width":"100%"},attrs:{"filterable":"","props":{emitPath:false},"show-all-levels":false,"value":_vm.value,"options":_vm.regionAllList,"clearable":""},on:{"change":_vm.change}})
}
var staticRenderFns = []

export { render, staticRenderFns }